import sendToast from './sendToast';

const fallbackCopyTextToClipboard = (text) => {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  try {
    return document.execCommand('copy');
  } catch (err) {}
  document.body.removeChild(textArea);
};
const copyToClipboard = (text, opts = {}) => {
  return new Promise((resolve) => {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text);
      resolve();
      return;
    }
    navigator.clipboard.writeText(text).then(
      function () {
        resolve();
      },
      function (err) {
        resolve(err);
      }
    );

    if (opts?.toast) {
      sendToast({ message: opts?.toastMessage || 'Copied to clipboard!' });
    }
  });
};

export default copyToClipboard;
